
export default {
  path: 'results',
  name: 'admin.event.discipline.results',
  component: () => import(/* webpackChunkName: "admin" */ 'client/admin/event/results/results.vue'),
};
